import React, { useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId, ZOCKS_CONTACT_FIELDS } from '../../../../../../../common/integrations'
import { MapContactFieldsSection } from './MapContactFieldsSection'
import { AdditionalFieldSelector } from '../AdditionalFieldSelector'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { IntegrationMappingFilterSection } from '../IntegrationMappingFilterSection'
import { DescriptorType, FilterExpression, FilterOperator } from '../../../../../../../models/Account'

interface CustomContactAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
}

export const CustomContactAdminSettings: React.FC<CustomContactAdminSettingsProps> = ({ serviceId, formKey = 0 }) => {
  const { watch } = useFormContext<IntegrationSettings>()
  const contactFields = watch('mappings.contact.fields')
  const syncOwnerField = watch('mappings.contact.sync.applyOwnerFilter')
  const alreadyAddedFieldKeys = useMemo(() => Object.keys(contactFields || {}), [contactFields])

  const coreFieldKeys = useMemo(() => ZOCKS_CONTACT_FIELDS.map((m) => m.zocksKey), [])
  const ownerFilterPlaceholder: FilterExpression = {
    field: `${getIntegrationDisplayName(serviceId)} Owner ID`,
    operator: FilterOperator.EQ,
    source: { value: 'User Id', type: DescriptorType.STATIC },
  }

  const contactPlaceholderFilters: FilterExpression[] = syncOwnerField ? [ownerFilterPlaceholder] : []

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <MapContactFieldsSection serviceId={serviceId} key={formKey} />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <IntegrationMappingFilterSection
            key={formKey}
            serviceId={serviceId}
            mappingKey='contact'
            title='Contact Filters'
            description={`Add filters to control which ${getIntegrationDisplayName(serviceId)} contacts sync to Zocks. Multiple filters are applied using AND logic - contacts must match all criteria.`}
            placeholderFilters={contactPlaceholderFilters}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <AdditionalFieldSelector
            title={`Field-Level Contact Updates`}
            description={`Select which ${getIntegrationDisplayName(serviceId)} fields to populate when Zocks creates or updates a contact.`}
            serviceId={serviceId}
            mappingObjectName='contact'
            ignoreKeys={coreFieldKeys}
            alreadyAddedFields={alreadyAddedFieldKeys}
          />
        </Col>
      </Row>
    </>
  )
}
